<!-- Task details -->
<!-- User info -->
<div class="flex flex-row text-md pl-4">
  <div class="flex flex-col w-2/3">
    <div class="flex flex-row">
      <fuse-card class="flex flex-col col-auto autosize m-2 bg-card w-1/2">
        <!-- Avatar & Info -->
        <div class="flex flex-col w-full p-4">
          <div class="flex flex-row text-md items-center ml-1">
            <mat-icon svgIcon="feather:user" class="icon-size-5 mr-3 items-start"></mat-icon>
            {{ user?.displayName }}
            <mat-icon svgIcon="iconsmind:pawn" class="icon-size-5 ml-5 mr-3 items-start"></mat-icon>
            {{ zombie?.name }}
          </div>
          @if (lastUserDevice) {
            <div class="flex flex-row text-md items-center ml-1 mb-1 mt-3">
              <mat-icon svgIcon="mat_solid:perm_device_information"
              class="icon-size-5 mr-3 items-start"></mat-icon>
              <div class="flex flex-col">
                <div class="flex flex-row">
                  {{ 'appVersion' | transloco }}: {{ lastUserDevice?.appVersion }}
                </div>
                <div class="flex flex-row">
                  {{ lastUserDevice?.deviceInfo.manufacturer }} {{ lastUserDevice?.deviceInfo.model }} {{ lastUserDevice?.deviceType}} {{ lastUserDevice?.deviceInfo.platformVersion }}
                </div>
              </div>
            </div>
          }
          <div class="flex flex-row text-secondary text-md items-center">
            @if (user?.sAMAccountName) {
              <button mat-icon-button class="mr-2 -ml-1">
                <mat-icon class="icon-size-5 text-hint" [svgIcon]="'iconsmind:id_card'"></mat-icon>
              </button>
            }
            DNI:&nbsp;{{ user?.sAMAccountName }}
            @if (user?.sAMAccountName) {
              <button mat-icon-button
                [cdkCopyToClipboard]="$safeNavigationMigration(user?.sAMAccountName)">
                <mat-icon class="icon-size-4" [svgIcon]="'mat_outline:content_copy'"></mat-icon>
              </button>
            }
          </div>
          <div class="flex flex-row text-secondary text-md items-center">
            @if (user?.userPrincipalName) {
              <button mat-icon-button class="mr-2 -ml-1">
                <mat-icon class="icon-size-5 text-hint" [svgIcon]="'heroicons_outline:mail'"></mat-icon>
              </button>
            }
            {{ user?.userPrincipalName }}
            @if (user?.userPrincipalName) {
              <button mat-icon-button
                [cdkCopyToClipboard]="$safeNavigationMigration(user?.userPrincipalName)">
                <mat-icon class="icon-size-4" [svgIcon]="'mat_outline:content_copy'"></mat-icon>
              </button>
            }
          </div>
          @if (user?.telephoneNumber) {
            <div
              class="flex flex-row text-secondary text-md items-center text-center">
              <button mat-icon-button class="mr-2 -ml-1">
                <mat-icon class="icon-size-5 text-hint" [svgIcon]="'heroicons_solid:phone'"></mat-icon>
              </button>
              {{ user?.telephoneNumber }}
              <button mat-icon-button [cdkCopyToClipboard]="$safeNavigationMigration(user?.telephoneNumber)">
                <mat-icon class="icon-size-4" [svgIcon]="'mat_outline:content_copy'"></mat-icon>
              </button>
            </div>
          }
          @if (task?.userId) {
            <div class="flex flex-row text-secondary text-md items-center justify-center">
              <button mat-stroked-button (click)="sendPush(connectedDevice)">
                <mat-icon class="icon-size-5" svgIcon="mat_outline:message"></mat-icon>
                <span class="ml-2">{{ 'sendMessage' | transloco }}</span>
              </button>
            </div>
          }
        </div>
      </fuse-card>
      <fuse-card [ngClass]="{'h-60': $safeNavigationMigration(user?.telephoneNumber)}" class="flex flex-col col-auto p-4 m-2 bg-card w-1/2">
        <div class="flex p-1 items-center">
          <mat-icon class="icon-size-7" [svgIcon]="'mat_outline:info'"></mat-icon>
          <span class="ml-2 font-bold text-md">{{ 'serviceInfo' | transloco }}</span>
        </div>
        <div class="flex p-2 items-center">
          <span class="ml-2 text-md">{{'id' | transloco}}: {{this.service?.serviceId }}</span>
        </div>
        <div class="flex p-2 items-center">
          <span class="ml-2 text-md">{{'name' | transloco}}: {{this.service?.name }}</span>
        </div>
        <div class="flex p-2 items-center">
          <span class="ml-2 text-md">
            {{ 'startDatePlaceholder' | transloco }}: {{ $safeNavigationMigration(service?.statusDate) | localizeDate:'longDate' }}
          </span>
        </div>
        <div class="flex p-2 pb-1 items-center">
          <span class="ml-2 text-md">
            {{ 'services.board.infoSidebar.status' | transloco }}: {{ ('services.status.' + $safeNavigationMigration(service?.statusLabel)) | transloco }}
          </span>
        </div>
      </fuse-card>
    </div>
    <div class="flex flex-row">
      <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full">
        <!-- Planned -->
        <div class="flex p-1 items-center mb-1">
          <mat-icon class="icon-size-7" [svgIcon]="'mat_solid:calendar_today'"></mat-icon>
          <span class="ml-2 font-bold text-md">{{ 'services.taskPlanning.planned' | transloco }}</span>
        </div>
        <div class="hidden sm:flex flex-col mx-1 text-center bg-white dark:bg-slate-800">
          @if ((task?.taskTypeTypology === 'WITH_TIME') && (task?.workDayTypeMode !== 'SPLIT') && (task?.scheduled_from_date)) {
            <ng-container *ngTemplateOutlet="plannedTimeConsumingNoSplitBO; context: { $implicit: task } ">
            </ng-container>
          }
          @if ((task?.taskTypeTypology === 'WITH_TIME') && (task?.workDayTypeMode === 'SPLIT') && (task?.scheduled_from_date)) {
            <ng-container *ngTemplateOutlet="plannedTimeConsumingSplitBO; context: { $implicit: task } ">
            </ng-container>
          }
          @if ((task?.taskTypeTypology === 'WITH_TIME') && (!task?.scheduled_from_date)) {
            <ng-container *ngTemplateOutlet="plannedTimeConsumingMobile; context: { $implicit: task } ">
            </ng-container>
          }
          @if ((task?.taskTypeTypology === 'WITHOUT_TIME') && (task?.scheduled_from_date)) {
            <ng-container *ngTemplateOutlet="plannedNoTimeConsumingBO; context: { $implicit: task } ">
            </ng-container>
          }
          @if ((task?.taskTypeTypology === 'WITHOUT_TIME') && (!task?.scheduled_from_date)) {
            <ng-container *ngTemplateOutlet="plannedNoTimeConsumingMobile; context: { $implicit: task } ">
            </ng-container>
          }
          @if ((task?.taskTypeTypology === 'TASK_ASSIGNMENT')) {
            <ng-container *ngTemplateOutlet="plannedTaskAssignment; context: { $implicit: task } ">
            </ng-container>
          }
        </div>
      </fuse-card>
      <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full">
        <!-- Done -->
        <div class="flex p-1 items-center mb-1">
          <mat-icon class="icon-size-7" [svgIcon]="'mat_solid:work'"></mat-icon>
          <span class="ml-2 font-bold text-md">{{ 'services.taskPlanning.done' | transloco}}</span>
        </div>
        <div class="hidden sm:flex flex-col mx-1 bg-white text-center dark:bg-slate-800">
          @if ((task?.taskTypeTypology === 'WITH_TIME') && (task?.workDayTypeMode !== 'SPLIT') && (!task?.parentTaskId)) {
            <ng-container *ngTemplateOutlet="doneTimeConsumingNoSplitBO; context: { $implicit: task } ">
            </ng-container>
          }
          @if ((task?.taskTypeTypology === 'WITH_TIME') && (task?.workDayTypeMode === 'SPLIT') && (!task?.parentTaskId)) {
            <ng-container *ngTemplateOutlet="doneTimeConsumingSplitBO; context: { $implicit: task } ">
            </ng-container>
          }
          @if (task?.parentTaskId) {
            <ng-container *ngTemplateOutlet="doneTimeConsumingMobile; context: { $implicit: task } ">
            </ng-container>
          }
          @if ((task?.taskTypeTypology === 'WITHOUT_TIME') && (!task?.parentTaskId)) {
            <ng-container *ngTemplateOutlet="doneNoTimeConsumingBO; context: { $implicit: task } ">
            </ng-container>
          }
          @if ((task?.taskTypeTypology === 'TASK_ASSIGNMENT')) {
            <ng-container *ngTemplateOutlet="doneTaskAssignment; context: { $implicit: task } ">
            </ng-container>
          }
        </div>
      </fuse-card>
    </div>

    <!-- Goals -->
    <div class="flex text-md w-full">
      <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full">
        <div class="flex flex-row p-2 items-center mb-2">
          <mat-icon class="icon-size-7" [svgIcon]="'feather:target'"></mat-icon>
          <span class="mx-2 font-bold text-md">
            {{ 'goal.taskGoals' | transloco }}
          </span>
          @if (canEditGoals()) {
            <button mat-icon-button (click)="editGoals()" matTooltip="{{ 'goal.edit' | transloco }}">
              <mat-icon [svgIcon]="'mat_outline:edit'"></mat-icon>
            </button>
          }
        </div>
        <!-- Header -->
                <div class="flex z-10 gap-4 shadow text-md font-semibold text-secondary
                            bg-gray-50 dark:bg-slate-900 w-full">
          <!-- Concept -->
          <div class="flex justify-start items-center py-4 px-2"
                        [ngClass]="{ 'w-5/12': task?.serverPayload?.goalStatus?.informative === false,
                            'w-1/2': task?.serverPayload?.goalStatus?.informative !== false }">
            {{ 'goal.concept' | transloco }}
          </div>
          @if (task?.serverPayload?.goalStatus?.informative === false) {
            <!-- Done -->
            <div class="flex justify-center items-center w-2/12 py-4 px-2">
              {{ 'goal.done' | transloco }}
            </div>
          }
          <!-- Goal -->
          <div class="flex justify-center items-center py-4 px-2"
                        [ngClass]="{ 'w-3/12': task?.serverPayload?.goalStatus?.informative === false,
                            'w-1/2': task?.serverPayload?.goalStatus?.informative !== false }">
            {{ 'goal.goal' | transloco }}
          </div>
          @if (task?.serverPayload?.goalStatus?.informative === false) {
            <!-- Percentage -->
            <div class="flex justify-center items-center w-2/12 py-4 px-2">
              {{ 'goal.fulfilled' | transloco }}
            </div>
          }
        </div>

        @if (task?.serverPayload?.goalStatus) {
          <!-- Rows -->
          @for (row of task.serverPayload.goalStatus.row; track row; let i = $index) {
            <div class="flex gap-4 border-b">
              @if (row.concept !== '_global' || !task.serverPayload.goalStatus.informative) {
                <!-- Concept -->
                <div class="flex justify-start items-center py-3 px-2"
                                [ngClass]="{ 'w-5/12': task?.serverPayload?.goalStatus?.informative === false,
                                    'w-1/2': task?.serverPayload?.goalStatus?.informative !== false }">
                  @if (row.concept !== '_global') {
                    {{ row.caption ? (row.caption | localize) : row.concept }}
                  }
                </div>
                @if (task?.serverPayload?.goalStatus?.informative === false) {
                  <!-- Done -->
                  <div class="flex justify-center items-center w-2/12 py-3 px-2">
                    @if (row.concept !== '_global') {
                      {{ row.goalDeliveryMode === 'UNITS' ? row.valueInUnits : row.valuePercent + ' %' }}
                    }
                  </div>
                }
                <!-- Goal -->
                <div class="flex justify-center items-center py-3 px-2"
                                [ngClass]="{ 'w-3/12': task?.serverPayload?.goalStatus?.informative === false,
                                    'w-1/2': task?.serverPayload?.goalStatus?.informative !== false,
                                    'font-semibold text-secondary bg-gray-50 dark:bg-slate-900': row.concept === '_global' }">
                  @if (row.concept !== '_global') {
                    {{ row.goal }} {{ row.goalDeliveryMode === 'UNITS' ? (row.goalUnitOfMeasurement | localize) : '%' }}
                  }
                  @if (!task.serverPayload.goalStatus.informative && row.concept === '_global') {
                    {{ 'goal.general' | transloco | uppercase }}
                  }
                </div>
                @if (task?.serverPayload?.goalStatus?.informative === false) {
                  <!-- Percentage -->
                  <div class="flex justify-center items-center w-2/12 py-3 px-2">
                    {{ row.percent }} %
                  </div>
                }
              }
            </div>
          }
        }
        @if (!task?.serverPayload?.goalStatus || task.serverPayload.goalStatus.row.length === 0) {
          <div class="flex justify-center items-center m-3">
            {{ 'goal.noTaskGoals' | transloco }}
          </div>
        }
      </fuse-card>
    </div>
    <!-- Files -->
    @if (taskOutputFile) {
      <div class="flex flex-row">
        <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full">
          <div class="flex flex-row p-2 items-center mb-2">
            <mat-icon class="icon-size-7" [svgIcon]="'feather:file'"></mat-icon>
            <span class="mx-2 font-bold text-md">
              {{ 'taskFiles.files' | transloco }}
            </span>
          </div>
          <!-- Header -->
                <div class="flex z-10 gap-4 shadow text-md font-semibold text-secondary py-2 px-4 sm:px-6
                            bg-gray-50 dark:bg-slate-900 w-full">
            <!-- File -->
            <div class="flex justify-start items-center flex-auto w-8">
              {{ 'taskFiles.file' | transloco }}
            </div>
            <!-- Score -->
            <div class="flex justify-center items-center flex-auto w-6">
              {{ 'taskFiles.score' | transloco }}
            </div>
            <!-- Send time -->
            <div class="flex justify-center items-center text-center flex-auto w-22">
              {{ 'taskFiles.sendTime' | transloco }}
            </div>
            <!-- Received time -->
            <div class="flex justify-center items-center text-center flex-auto w-22">
              {{ 'taskFiles.receivedTime' | transloco }}
            </div>
            <!-- Estado -->
            <div class="flex justify-center items-center flex-auto w-16">
              {{ 'taskFiles.status' | transloco }}
            </div>
            <!-- Acciones -->
            <div class="flex justify-center items-center flex-auto w-12">
              {{ 'taskFiles.actions' | transloco }}
            </div>
          </div>
          @if (taskOutputFile.length > 0) {
            <!-- Rows -->
            @for (file of taskOutputFile; track file; let i = $index) {
              <div class="flex gap-4 border-b py-2 px-4 sm:px-6">
                <!-- File -->
                <a (click)="downloadTaskFile(file)" class="flex justify-start items-center flex-auto w-8 text-primary-500 cursor-pointer">
                  {{ file.title }}
                </a>
                <!-- Score -->
                <div class="flex justify-center items-center flex-auto w-6">
                  {{ file.score ?? '-' }}
                </div>
                <!-- Send time -->
                <div class="flex justify-center items-center flex-auto w-22">
                  {{ file.sendTime | localizeDate:'dd/MM/yyyy HH:mm' }}
                </div>
                <!-- Received time -->
                <div class="flex justify-center items-center flex-auto w-22">
                  {{ file.receivedTime | localizeDate:'dd/MM/yyyy HH:mm' }}
                </div>
                <!-- Estado -->
                <div class="flex justify-center items-center flex-auto w-16">
                  {{ 'taskFiles.' + file.status | transloco }}
                </div>
                <!-- Acciones -->
                <div class="flex justify-center items-center flex-auto w-12">
                  <button mat-button [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation()">{{ 'taskFiles.actions' | transloco }}</button>
                  <mat-menu #actionMenu="matMenu">
                    <!-- Edit -->
                    @if (file.action?.generate) {
                      <button mat-menu-item (click)="executeTaskCustomAction('generate')">
                        {{ file.action.generate.caption | localize }}
                      </button>
                    }
                    <!-- Delete -->
                    @if (file.action?.send) {
                      <button mat-menu-item (click)="executeTaskCustomAction('send')">
                        {{ file.action.send.caption | localize }}
                      </button>
                    }
                  </mat-menu>
                </div>
              </div>
            }
          }
          @if (taskOutputFile.length === 0) {
            <div class="flex justify-center items-center m-3">
              {{ 'taskFiles.noTaskFiles' | transloco }}
            </div>
          }
        </fuse-card>
      </div>
    }
  </div>

  <div class="flex flex-col w-1/2">
    <!-- Map -->
    <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full" [class.hidden]="!task?.addressOid && !taskGeopositionSummary">
      <div class="flex flex-col">
        <div class="flex flex-row">
          <div class="border-2 border-solid border-black z-0 w-full">
            <div class="h-80" id="mapId" #mapId></div>
          </div>
        </div>
        <div class="flex flex-row mt-2">
          <div class="flex flex-col justify-center">
            @if (task?.addressOid) {
              <div class="flex flex-row items-center m-2 cursor-pointer" (click)="goToMarker(0)">
                <div class="flex flex-row items-center mt-2 mr-2 font-bold text-md">
                  <mat-icon [svgIcon]="'position-marker-0'" class="icon-size-10"></mat-icon>
                  <span class="text-primary-500">
                    {{ task?.addressName }} - {{ task?.addressVicinity }}
                  </span>
                  @if (task?.addressIsDirty) {
                    <button mat-icon-button (click)="openChangeLocationModal()" [matTooltip]="'changeLocationTooltip' | transloco">
                      <mat-icon [svgIcon]="'mat_outline:pending_actions'"></mat-icon>
                    </button>
                  }
                </div>
              </div>
            }
            @if (taskGeopositionSummary) {
              <div class="flex flex-row m-2">
                <div class="flex flex-col">
                  @if (hasGeoposition(1)) {
                    <div (click)="goToMarker(1)"
                      class="flex flex-row cursor-pointer">
                      <div class="flex items-center mt-2 font-bold text-md">
                        <mat-icon svgIcon="position-marker-1" class="icon-size-10"></mat-icon>
                        <span class="text-primary-500">{{ 'startTask' | transloco }}
                          @if (task.workDayTypeMode === 'SPLIT') {
                            <span>
                              ({{ 'firstPartOfWorkday' | transloco }})
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                  }
                  @if (hasGeoposition(2)) {
                    <div (click)="goToMarker(2)" class="flex cursor-pointer">
                      <div class="flex items-center mt-2 font-bold text-md"><mat-icon
                      svgIcon="position-marker-2" class="icon-size-10"></mat-icon><span
                      class="text-primary-500">{{ 'endTask' | transloco }}
                      @if (task.workDayTypeMode === 'SPLIT') {
                        <span>({{ 'firstPartOfWorkday' |
                        transloco }})</span>
                      }
                    </span>
                  </div>
                </div>
              }
            </div>
            <div [ngClass]="{'ml-5': (hasGeoposition(1) || hasGeoposition(2))}"
              class="flex flex-col">
              @if (hasGeoposition(3)) {
                <div (click)="goToMarker(3)"
                  class="flex flex-row cursor-pointer">
                  <div class="flex flex-row items-center mt-2 font-bold text-md">
                    <mat-icon svgIcon="position-marker-3" class="icon-size-10"></mat-icon>
                    <span class="text-primary-500">
                      {{ 'startTask' | transloco }}
                      <span>({{ 'secondPartOfWorkday' | transloco }})</span>
                    </span>
                  </div>
                </div>
              }
              @if (hasGeoposition(4)) {
                <div (click)="goToMarker(4)" class="flex cursor-pointer">
                  <div class="flex items-center mt-2 font-bold text-md">
                    <mat-icon svgIcon="position-marker-4" class="icon-size-10"></mat-icon>
                    <span class="text-primary-500">
                      {{ 'endTask' | transloco }}
                      <span>({{ 'secondPartOfWorkday' | transloco }})</span>
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <!-- <div class="flex justify-center text-center">
    <div class="mt-2 font-bold text-md">{{ task?.addressName }}</div>
  </div>
  <div class="flex justify-center text-center">
    <div class="text-secondary text-md">{{ task?.addressVicinity }}</div>
  </div> -->
</div>
</fuse-card>
<!-- Extra data -->
@if (hasExtraPayload()) {
  <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full">
    <div class="flex flex-row p-2 items-center mb-2">
      <mat-icon class="icon-size-7" [svgIcon]="'feather:archive'"></mat-icon>
      <span class="mx-2 font-bold text-md">
        {{ 'extraFields' | transloco }}
      </span>
    </div>
    <!-- Header -->
    <div class="flex z-10 gap-4 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-slate-900 w-full">
      <div class="flex justify-center items-center py-4 px-2 w-1/2">
        {{ 'field' | transloco }}
      </div>
      <div class="flex justify-center items-center py-4 px-2 w-1/2">
        {{ 'value' | transloco }}
      </div>
    </div>
    <!-- Rows -->
    @for (field of task.serverPayload.extraPayload | keyvalue; track field) {
      <div class="flex gap-4 border-b">
        <div class="flex justify-center items-center py-3 px-2 w-1/2">
          {{ field.key }}
        </div>
        <div class="flex justify-center items-center py-3 px-2 w-1/2">
          {{ field.value }}
        </div>
      </div>
    }
  </fuse-card>
}
</div>
</div>

<div class="flex flex-row text-md w-full pl-4">
  <!-- Forms -->
  <div class="flex flex-col w-full">
    <div class="flex flex-row">
      <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full">
        <div class="flex flex-row p-2 justify-between items-center mb-2">
          <div class="flex items-center">
            <mat-icon class="icon-size-7" [svgIcon]="'mat_outline:aod'"></mat-icon>
            <span class="mx-2 font-bold text-md">{{ 'services.taskPlanning.taskForms' | transloco }}</span>
            <button mat-icon-button (click)="showFormSummaryToggle()">
              <mat-icon class="icon-size-7" [svgIcon]="hideForms ? 'feather:chevron-down' : 'feather:chevron-up'"></mat-icon>
            </button>
            @if (task?.status === 'DONE' || task?.status === 'DONE_WITH_ERROR' || task?.status === 'CANCELLED' || task?.status === 'SUSPENDED') {
              <button mat-button (click)="addNewForm()">
                <mat-icon class="icon-size-7" [svgIcon]="'mat_outline:add'"></mat-icon>
                {{ 'services.taskPlanning.newReply' | transloco }}
              </button>
            }
          </div>
          @if (task) {
            <button mat-stroked-button routerLink="../forms" [queryParams]="{ taskId: task.taskId }">
              <mat-icon class="icon-size-5" svgIcon="heroicons_solid:external-link"></mat-icon>
              <span class="ml-2">{{ 'serviceForms.goToForms' | transloco }}</span>
            </button>
          }
        </div>
        @if (formFilter.size > 1) {
          <mat-button-toggle-group class="py-2" [formControl]="formFilterControl" multiple>
            @for (form of formFilter | keyvalue; track form) {
              <mat-button-toggle [value]="form.key">
                {{ form.value.formName | localize }} ({{ form.value.replies }})
                @if (form.value.deprecated) {
                  <mat-icon [svgIcon]="'mat_outline:error_outline'" matTooltip="{{ 'deprecated' | transloco }}"></mat-icon>
                }
              </mat-button-toggle>
            }
          </mat-button-toggle-group>
        }
        <div [class.hidden]="hideForms">
          <!-- Header -->
                    <div #formsSort="matSort" class="flex z-10 text-md gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
                                bg-gray-50 dark:bg-slate-900" matSort matSortDisableClear [matSortActive]="'creationDate'" [matSortDirection]="'desc'">
            <!--Form-->
            <div class="flex items-center flex-auto w-16 3xl:w-96" [mat-sort-header]="'caption'">
              {{ 'services.taskPlanning.form' | transloco }}
            </div>
            <!-- OID -->
            <div class="flex items-center flex-auto w-16">
              {{ 'services.taskPlanning.formId' | transloco }}
            </div>
            <!-- creationDate -->
            <div class="flex items-center flex-auto w-16" [mat-sort-header]="'creationDate'">
              {{ 'services.taskPlanning.creationDate' | transloco }}
            </div>
            <!-- queueDate -->
            <div class="flex items-center flex-auto w-16" [mat-sort-header]="'queueDate'">
              {{ 'services.taskPlanning.queueDate' | transloco }}
            </div>
            <!-- receivedDate -->
            <div class="flex items-center flex-auto w-16" [mat-sort-header]="'receivedDate'">
              {{ 'services.taskPlanning.receivedDate' | transloco }}
            </div>
            @if (['DONE', 'DONE_WITH_ERROR', 'SUSPENDED', 'CANCELLED'].includes($safeNavigationMigration(task?.status))) {
              <div class="flex-initial w-8"></div>
            }
          </div>

          <!-- Rows -->
          @for (form of taskFormSummaryForView; track form) {
            <div class="flex gap-4 py-3 px-4 sm:px-6 border-b">
              <!--Form-->
              <div class="flex items-center flex-auto w-16 3xl:w-96">
                <a (click)="openTaskFormDialog(form.oid)"
                  class="text-primary-500 cursor-pointer">
                  {{ form.caption | localize }}
                </a>
              </div>
              <!-- OID -->
              <div class="flex items-center flex-auto w-16">
                {{ form.oid }}
              </div>
              <!-- creationDate -->
              <div class="flex items-center flex-auto w-16">
                {{ form.creationDate | localizeDate:'dd/MM/yyyy HH:mm' }}
              </div>
              <!-- queueDate -->
              <div class="flex items-center flex-auto w-16">
                {{ form.queueDate | localizeDate:'dd/MM/yyyy HH:mm' }}
              </div>
              <!-- receivedDate -->
              <div class="flex items-center flex-auto w-16">
                {{ form.receivedDate | localizeDate:'dd/MM/yyyy HH:mm' }}
              </div>
              @if (['DONE', 'DONE_WITH_ERROR', 'SUSPENDED', 'CANCELLED'].includes($safeNavigationMigration(task?.status))) {
                <div class="flex items-center flex-initial w-8">
                  <button mat-icon-button (click)="deleteForm(form)" matTooltip="{{ 'delete' | transloco }}">
                    <mat-icon [svgIcon]="'mat_outline:delete'"></mat-icon>
                  </button>
                </div>
              }
            </div>
          }
          @if (taskFormSummaryForView.length === 0) {
            <div class="flex justify-center items-center m-8">
              {{ 'services.taskPlanning.noTaskForms' | transloco }}
            </div>
          }
          <mat-paginator #formsPaginator
            class="border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 dark:bg-transparent"
            [length]="$safeNavigationMigration(formPagination?.length)" [pageIndex]="$safeNavigationMigration(formPagination?.page)" [pageSize]="$safeNavigationMigration(formPagination?.size)" [hidePageSize]="true"
          [showFirstLastButtons]="true"></mat-paginator>
        </div>
      </fuse-card>
    </div>
  </div>
</div>

<div class="flex flex-row text-md pl-4">
  <!-- TaskTracking -->
  <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full">
    <div (click)="showEventsToggle()" class="flex flex-row p-2 items-center mb-2 cursor-pointer">
      <mat-icon class="icon-size-7" [svgIcon]="'mat_outline:event_note'"></mat-icon>
      <span class="mx-2 font-bold text-md">{{ 'taskTrackingTitle' | transloco }}</span>
      @if (hideEvents) {
        <mat-icon class="icon-size-7" [svgIcon]="'feather:chevron-down'"></mat-icon>
      }
      @if (!hideEvents) {
        <mat-icon class="icon-size-7" [svgIcon]="'feather:chevron-up'"></mat-icon>
      }
    </div>
    <div [class.hidden]="hideEvents">
      <!-- Header -->
            <div #trackingSort="matSort" class="flex z-10 text-md gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
                       bg-gray-50 dark:bg-slate-900 w-full" matSort matSortDisableClear [matSortActive]="'timestamp'" [matSortDirection]="'desc'">
        <!--Events-->
        <div class="flex items-center text-center flex-auto w-64" [mat-sort-header]="'event'">
          {{ 'services.taskPlanning.events' | transloco }}
        </div>
        <!-- Date and time -->
        <div class="flex items-center text-center flex-auto w-64" [mat-sort-header]="'timestamp'">
          {{ 'services.taskPlanning.dateAndTime' | transloco }}
        </div>
        <!-- User -->
        <div class="flex items-center text-center flex-auto w-64" [mat-sort-header]="'userName'">
          {{ 'services.taskPlanning.user' | transloco }}
        </div>
      </div>

      <!-- Rows -->
      @for (event of taskTrackingForView; track event) {
        <div class="flex gap-4 py-3 px-4 sm:px-6 border-b">
          <!--Events-->
          <div class="flex justify-start flex-auto w-64">
            {{ $safeNavigationMigration(event?.event) | transloco }}
          </div>
          <!-- Date and time -->
          <div class="flex items-center text-center flex-auto w-64">
            {{ $safeNavigationMigration(event?.timestamp) | localizeDate: 'dd/MM/yyyy HH:mm' }}
          </div>
          <!-- User -->
          <div class="flex items-center flex-auto w-64">
            {{ event?.userName }}
          </div>
        </div>
      }
      @if (taskTracking.length === 0) {
        <div class="text-center items-center m-8">
          {{ 'services.taskPlanning.noTaskEvents' | transloco }}
        </div>
      }
      <mat-paginator #trackingPaginator
        class="border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 dark:bg-transparent"
        [length]="$safeNavigationMigration(trackingPagination?.length)" [pageIndex]="$safeNavigationMigration(trackingPagination?.page)" [pageSize]="$safeNavigationMigration(trackingPagination?.size)" [hidePageSize]="true"
      [showFirstLastButtons]="true"></mat-paginator>
    </div>
  </fuse-card>
</div>

<div class="flex flex-row text-md pl-4 w-full">
  <div class="flex flex-row w-full">
    <!-- TaskEventSummary -->
    <fuse-card class="flex flex-col col-auto p-4 m-2 bg-card w-full">
      <div (click)="showMessagesToggle()" class="flex flex-row p-2 items-center mb-2 cursor-pointer">
        <mat-icon class="icon-size-7" [svgIcon]="'mat_outline:message'"></mat-icon>
        <span class="mx-2 font-bold text-md">{{ 'taskEventSummaryTitle' | transloco }}</span>
        @if (hideMessages) {
          <mat-icon class="icon-size-7" [svgIcon]="'feather:chevron-down'"></mat-icon>
        }
        @if (!hideMessages) {
          <mat-icon class="icon-size-7" [svgIcon]="'feather:chevron-up'"></mat-icon>
        }
      </div>
      @if (!hideMessages) {
        <div class="grid">
          <!-- Header -->
                <div class="events-grid z-10 text-md sticky top-0 grid gap-4 py-4 px-4 md:px-6 shadow text-md font-semibold text-secondary
                            bg-gray-50 dark:bg-slate-900">
            <!--Events-->
            <div class="flex text-center justify-start">
              {{ 'services.taskPlanning.events' | transloco}}
            </div>
            <!-- Date and time -->
            <div class="flex text-center justify-start">
              {{ 'services.taskPlanning.dateAndTime' | transloco}}
            </div>
            <!-- ACK -->
            <div class="flex text-center justify-start">
              ACK ({{ 'received' | transloco }})
            </div>
            <!-- RC -->
            <div class="flex text-center justify-start">
              RC ({{ 'readed' | transloco }})
            </div>
            <!-- User -->
            <div class="flex items-center justify-start">
              {{ 'services.taskPlanning.user' | transloco}}
            </div>
          </div>
          <!-- Rows -->
          @for (event of taskEventSummary; track event; let i = $index) {
            <div class="events-grid grid gap-4 py-3 px-4 md:px-6 border-b">
              <!--Events-->
              <div class="flex items-center justify-start">
                {{ $safeNavigationMigration(event?.event) | transloco }}
                @if (event?.payload) {
                  <div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                    <button mat-icon-button (click)="toggleMessage(event, $event)"
                      matTooltip="{{ 'messageInfo' | transloco }}"
                      matTooltipClass="my-custom-tooltip">
                      <mat-icon [svgIcon]="'mat_outline:info'">
                      </mat-icon>
                    </button>
                    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                      [cdkConnectedOverlayOpen]="event.showInfo">
                      <ng-container
                        *ngTemplateOutlet="infoMessageTooltip; context: { $implicit: event } ">
                      </ng-container>
                    </ng-template>
                  </div>
                }
              </div>
              <!-- Date and time -->
              <div class="flex items-center justify-start">
                {{ $safeNavigationMigration(event?.timestamp) | localizeDate: 'dd/MM/yyyy HH:mm' }}
              </div>
              <!-- ACK -->
              <div class="flex items-center justify-start">
                {{ $safeNavigationMigration(event?.ack) | localizeDate: 'dd/MM/yyyy HH:mm' }}
              </div>
              <!-- RC -->
              <div class="flex items-center justify-start">
                {{ $safeNavigationMigration(event?.rc) | localizeDate: 'dd/MM/yyyy HH:mm' }}
              </div>
              <!-- User -->
              <div class="flex items-center justify-start">
                {{ event?.userName }}
              </div>
            </div>
          }
          <ng-container>
            @if (!taskEventSummary) {
              <div class="text-center items-center m-3">
                {{ 'services.taskPlanning.noTaskMessages' | transloco}}
              </div>
            }
          </ng-container>
        </div>
      }
    </fuse-card>
  </div>
</div>
<ng-template #infoMessageTooltip let-event>
  <div class="flex border rounded bg-white my-custom-tooltip">
    <div class="flex flex-col px-3 py-2">
      <div class="flex flex-row mt-2">
        <b class="mr-8 -mt-1">{{ $safeNavigationMigration(event?.payload?.title) | localize }}</b>
        <button mat-icon-button (click)="event.showInfo = false" class="absolute top-0 right-0 m-1">
          <mat-icon [svgIcon]="'mat_outline:close'" class="icon-size-5"></mat-icon>
        </button>
      </div>
      <!-- <div class="flex flex-row mt-2 mb-2">
      <span *ngIf="event.payload.title">- {{ 'title' | transloco: { title: (event?.payload?.title | localize) } }} </span>
    </div> -->
    <div class="flex flex-row mt-2 mb-2">
      <!-- <span *ngIf="event.payload.message">- {{ 'message' | transloco: { message: (event?.payload?.message | localize) } }} </span> -->
      @if (event.payload.message) {
        <span>{{ $safeNavigationMigration(event?.payload?.message) | localize }} </span>
      }
    </div>
    <div class="flex flex-col w-1/4"></div>
  </div>
</div>
</ng-template>

<!-- COLUMNA PLANIFICADO TAREAS QUE CONSUMEN TIEMPO CON JORNADA NO PARTIDA CREADAS DESDE BACKOFFICE -->
<ng-template #plannedTimeConsumingNoSplitBO let-task>
  @if (task.workDayTypeDescription.length !== 0) {
    <div class="flex flex-row justify-center border">
      {{ task.workDayTypeDescription | localize }}
    </div>
  }
  @if (task.workDayTypeDescription.length === 0) {
    <div class="flex flex-row justify-center border">
      <br>
      </div>
    }
    <div class="flex flex-row bg-slate-100 border dark:bg-slate-900">
      @if (task.scheduled_from_time) {
        <div class="flex flex-col w-1/2">
          {{ task.scheduled_from_time | localizeDate: 'dd/MM/yyyy' }}
        </div>
        <div class="flex flex-col w-1/2">
          {{ task.scheduled_from_time | localizeDate: 'H:mm' }}
        </div>
      }
      @if (!task.scheduled_from_time) {
        <div class="flex flex-col w-1/2">
          {{ task.scheduled_from_date | localizeDate: 'dd/MM/yyyy' }}
        </div>
        <div class="flex flex-col w-1/2">
          <br>
          </div>
        }
      </div>
      <div class="flex flex-row border">
        <div class="flex flex-col w-1/2">
          <div></div>
        </div>
        @if (task.scheduled_to_time) {
          <div class="flex flex-col w-1/2">
            {{ task.scheduled_to_time | localizeDate: 'H:mm' }}
          </div>
        }
        @if (!task.scheduled_to_time) {
          <div class="flex flex-col w-1/2">
            <br>
            </div>
          }
        </div>
      </ng-template>

      <!-- COLUMNA PLANIFICADO TAREAS QUE CONSUMEN TIEMPO CON JORNADA PARTIDA CREADAS DESDE BACKOFFICE -->
      <ng-template #plannedTimeConsumingSplitBO let-task>
        <div class="flex flex-row justify-center border">
          {{ task.workDayTypeDescription | localize }}
        </div>
        <div class="flex flex-row bg-slate-100 border dark:bg-slate-900">
          <div class="flex flex-col w-1/2">
            {{ task.scheduled_from_time | localizeDate: 'dd/MM/yyyy' }}
          </div>
          <div class="flex flex-col w-1/2">
            {{ task.scheduled_from_time | localizeDate: 'H:mm' }}
          </div>
        </div>
        <div class="flex flex-row border">
          <div class="flex flex-col w-1/2">
            <div></div>
          </div>
          <div class="flex flex-col w-1/2">
            {{ task.scheduled_to_time | localizeDate: 'H:mm' }}
          </div>
        </div>
        <div class="flex flex-row bg-slate-100 border dark:bg-slate-900">
          <div class="flex flex-col w-1/2">
            {{ task.scheduled_from_time2 | localizeDate: 'dd/MM/yyyy' }}
          </div>
          <div class="flex flex-col w-1/2">
            {{ task.scheduled_from_time2 | localizeDate: 'H:mm' }}
          </div>
        </div>
        <div class="flex flex-row border">
          <div class="flex flex-col w-1/2">
            <div></div>
          </div>
          <div class="flex flex-col w-1/2">
            {{ task.scheduled_to_time2 | localizeDate: 'H:mm' }}
          </div>
        </div>
      </ng-template>

      <!-- COLUMNA PLANIFICADO TAREAS QUE CONSUMEN TIEMPO CREADAS DESDE EL MÓVIL -->
      <ng-template #plannedTimeConsumingMobile let-task>
        <div class="flex flex-row justify-center border">
          {{ 'services.taskPlanning.taskCreatedFromDevice' | transloco }}
        </div>
        <div class="flex flex-row justify-center border bg-slate-100 dark:bg-slate-900">
          {{ task.startTaskDate | localizeDate: 'dd/MM/yyyy' }}
        </div>
        <div class="flex flex-row justify-center border">
          <br>
          </div>
        </ng-template>

        <!-- COLUMNA PLANIFICADO TAREAS QUE NO CONSUMEN TIEMPO CREADAS DESDE EL BACKOFFICE -->
        <ng-template #plannedNoTimeConsumingBO let-task>
          <div class="flex flex-row justify-center border">
            {{ 'services.taskPlanning.sentDate' | transloco }}
          </div>
          <div class="flex flex-row justify-center border bg-slate-100 dark:bg-slate-900">
            <div class="flex flex-col w-1/2">
              {{ task.scheduled_from_time | localizeDate: 'dd/MM/yyyy' }}
            </div>
            <div class="flex flex-col w-1/2">
              {{ task.scheduled_from_time | localizeDate: 'H:mm' }}
            </div>
          </div>
          <div class="flex flex-row justify-center border">
            {{ 'services.taskPlanning.deadline' | transloco }}
          </div>
          <div class="flex flex-row justify-center border bg-slate-100 dark:bg-slate-900">
            <div class="flex flex-col w-1/2">
              {{ task.scheduled_to_time | localizeDate: 'dd/MM/yyyy' }}
            </div>
            <div class="flex flex-col w-1/2">
              {{ task.scheduled_to_time | localizeDate: 'H:mm' }}
            </div>
          </div>
        </ng-template>

        <!-- COLUMNA PLANIFICADO TAREAS QUE NO CONSUMEN TIEMPO CREADAS DESDE EL MOVIL -->
        <ng-template #plannedNoTimeConsumingMobile let-task>
          <div class="flex flex-row justify-center border">
            {{ 'services.taskPlanning.taskCreatedFromDevice' | transloco }}
          </div>
          <div class="flex flex-row justify-center border bg-slate-100 dark:bg-slate-900">
            {{ 'services.taskPlanning.started' | transloco }}
          </div>
          <div class="flex flex-row justify-center border">
            {{ 'services.taskPlanning.ended' | transloco }}
          </div>
        </ng-template>

        <!-- COLUMNA PLANIFICADO ASIGNACIÓN DE TAREAS -->
        <ng-template #plannedTaskAssignment let-task>
          <div class="flex flex-row justify-center border">
            {{ 'services.taskPlanning.tasksAssigned' | transloco }}
          </div>
          <div class="flex flex-row justify-center bg-slate-100 border dark:bg-slate-900">
            {{ 'services.taskPlanning.start' | transloco }}
          </div>
          <div class="flex flex-row justify-center border">
            {{ 'services.taskPlanning.end' | transloco }}
          </div>
          @if (task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
            <div class="flex flex-row justify-center bg-slate-100 border dark:bg-slate-900">
              <br>
              </div>
            }
            @for (taskType of task.taskAssignmentSummary; track taskType; let i = $index) {
              <div
                [ngClass]="{'bg-slate-100 dark:bg-slate-900': indexImpar(i, task)}"
                class="flex flex-row justify-center truncate border">
                {{ taskType.taskTypeName }}
              </div>
            }

          </ng-template>

          <!-- COLUMNA REALIZADO TAREAS QUE CONSUMEN TIEMPO CON JORNADA NO PARTIDA CREADAS DESDE BACKOFFICE -->
          <ng-template #doneTimeConsumingNoSplitBO let-task>
            <div class="flex flex-row justify-center border">
              <div class="flex flex-col w-1/2">
                @if (task.startTaskDate) {
                  <div matTooltip="{{ 'services.taskPlanning.workingTime' | transloco }}">
                    {{ workingTime(task) }}
                  </div>
                }
                @if (!task.startTaskDate) {
                  <div>
                    <br>
                    </div>
                  }
                </div>
                @if (task.status === 'DONE' || task.status === 'DONE_WITH_ERROR') {
                  <div
                    matTooltip="{{ 'services.taskPlanning.differenceStartEndTime' | transloco }}"
                    [ngClass]="{'warning-icon': task.startEndDifferenceMinutes < 0}" class="flex flex-col w-1/2">
                    {{ differenceStartEndTime(task) }}
                  </div>
                }
              </div>
              <div class="flex flex-row justify-center bg-slate-100 border dark:bg-slate-900">
                {{ timeRemainingToStart(task) }}
                @if (task?.timeRemainingToStart < 0) {
                  <div class="flex flex-row text-green-500">
                    {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToStart)) }}
                  </div>
                }
                @if (task?.timeRemainingToStart > 0 && task.status === 'WITHERROR') {
                  <div class="flex flex-row text-green-500">
                    <br>
                    </div>
                  }
                  @if (task?.timeRemainingToStart >= 0) {
                    <div class="flex flex-col w-1/2">
                      @if (task.startTaskDate) {
                        <div>
                          {{ task.startTaskDate | localizeDate: 'H:mm' }}
                        </div>
                      }
                    </div>
                  }
                  @if (task?.timeRemainingToStart >= 0) {
<div [ngClass]="{'warning-icon': task.delayedStart && getTrackingEvent(task) !== 'DELAYED_START', 
                        'error-icon': task.delayedStart && getTrackingEvent(task) === 'DELAYED_START'}"
                      class="flex flex-col w-1/2">
                      {{ getStartTimeDiference(task) }}
                    </div>
                  }
                </div>
                <div class="flex flex-row justify-center border">
                  {{ timeRemainingToEnd(task) }}
                  @if (task?.timeRemainingToStart < 0 || getTrackingEvent(task) === 'SENT' || getTrackingEvent(task) === 'PLANNED' || getTrackingEvent(task) === 'WITHERROR' || getTrackingEvent(task) === 'DELAYED_START') {
                    <div
                      >
                      <br>
                      </div>
                    }
                    @if (task?.timeRemainingToEnd > 0 && getTrackingEvent(task) === 'WORKING') {
                      <div class="flex flex-row text-green-500 text-center"
                        >
                        {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToEnd)) }}
                      </div>
                    }
                    @if (task?.timeRemainingToEnd < 0 || getTrackingEvent(task) === 'DONE' || getTrackingEvent(task) === 'DONE_WITH_ERROR') {
                      <div class="flex flex-col w-1/2">
                        @if (task.endTaskDate) {
                          <div>
                            {{ task.endTaskDate |localizeDate: 'H:mm' }}
                          </div>
                        }
                      </div>
                    }
                    @if ((task?.timeRemainingToEnd < 0 && getTrackingEvent(task) !== 'DONE' && getTrackingEvent(task) !== 'DONE_WITH_ERROR')) {
                      <div class="flex flex-col w-1/2">
                        <br>
                        </div>
                      }
                      @if ((task.startTaskDate && task.status !== 'WORKING')
                        || getTrackingEvent(task) === 'DONE' || getTrackingEvent(task) === 'DONE_WITH_ERROR' || getTrackingEvent(task) === 'DELAYED_END') {
<div [ngClass]="{'warning-icon': task.delayedEnd && getTrackingEvent(task) !== 'DELAYED_END', 
                        'error-icon': task.delayedEnd && getTrackingEvent(task) === 'DELAYED_END'}"
                          class="flex flex-col w-1/2">
                          {{ getEndTimeDiference(task) }}
                        </div>
                      }
                    </div>
                  </ng-template>

                  <!-- COLUMNA REALIZADO TAREAS QUE CONSUMEN TIEMPO CON JORNADA PARTIDA CREADAS DESDE BACKOFFICE -->
                  <ng-template #doneTimeConsumingSplitBO let-task>
                    @if (task.status !== 'PLANNED' && task.status !== 'WITHERROR' && task.status !== 'SENT') {
                      <div class="flex flex-row justify-center border"
                        >
                        <div class="flex flex-col w-1/2">
                          @if (task.startTaskDate || task.startTaskDate2) {
                            <div matTooltip="{{ 'services.taskPlanning.workingTime' | transloco }}"
                              >
                              {{ workingTime(task) }}
                            </div>
                          }
                        </div>
                        @if (task.status === 'DONE' || task.status === 'DONE_WITH_ERROR') {
                          <div matTooltip="{{ 'services.taskPlanning.differenceStartEndTime' | transloco }}"
                            [ngClass]="{'warning-icon': task.startEndDifferenceMinutes < 0}"
                            class="flex flex-col w-1/2">
                            {{ differenceStartEndTime(task) }}
                          </div>
                        }
                        @if (task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
                          <div class="flex flex-col w-1/2">
                            <div></div>
                          </div>
                        }
                      </div>
                    }
                    @if (task.status === 'PLANNED' || task.status === 'WITHERROR' || task.status === 'SENT') {
                      <div class="flex flex-row justify-center border"
                        >
                        <br>
                        </div>
                      }
                      <div class="flex flex-row justify-center bg-slate-100 border dark:bg-slate-900">
                        @if (!task.startTaskDate) {
                          <div>
                            <br>
                            </div>
                          }
                          {{ timeRemainingToStart(task) }}
                          @if (task?.timeRemainingToStart < 0 && !task.startTaskDate2) {
                            <div class="flex flex-row text-green-500"
                              >
                              {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToStart)) }}
                            </div>
                          }
                          @if (task?.timeRemainingToStart >= 0 || task?.startTaskDate) {
                            <div class="flex flex-col w-1/2">
                              @if (task.startTaskDate) {
                                <div>
                                  {{ task.startTaskDate | localizeDate: 'H:mm' }}
                                </div>
                              }
                            </div>
                          }
                          @if ((getTrackingEvent(task) !=='WITHERROR'
                            || getTrackingEvent(task) !=='PLANNED' || getTrackingEvent(task) !=='SENT') && task?.startTaskDate) {
<div [ngClass]="{'warning-icon': task.delayedStart && getTrackingEvent(task) !== 'DELAYED_START', 
                        'error-icon': task.delayedStart && getTrackingEvent(task) === 'DELAYED_START'}"
                              class="flex flex-col w-1/2">
                              {{ getStartTimeDiference(task) }}
                            </div>
                          }
                        </div>
                        <div class="flex flex-row justify-center border">
                          {{ timeRemainingToEnd(task) }}
                          @if (task?.timeRemainingToStart < 0 || getTrackingEvent(task) === 'SENT' || getTrackingEvent(task) === 'PLANNED' || getTrackingEvent(task) === 'DELAYED_START' ||
                            !task.startTaskDate) {
                            <div class="bg-slate-100 dark:bg-slate-900">
                              <br>
                              </div>
                            }
                            @if (task?.timeRemainingToEnd > 0 && getTrackingEvent(task) === 'WORKING' && !task.startTaskDate2) {
                              <div class="flex flex-row text-green-500 text-center"
                                >
                                {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToEnd)) }}
                              </div>
                            }
                            @if (task?.timeRemainingToEnd < 0 || getTrackingEvent(task) === 'DONE' || getTrackingEvent(task) === 'DONE_WITH_ERROR' || getTrackingEvent(task) === 'PAUSED') {
                              <div class="flex flex-col w-1/2"
                                >
                                @if (task.endTaskDate) {
                                  <div>
                                    {{ task.endTaskDate | localizeDate: 'H:mm' }}
                                  </div>
                                }
                              </div>
                            }
                            @if (task.startTaskDate && task.endTaskDate) {
<div [ngClass]="{'warning-icon': task.delayedEnd && getTrackingEvent(task) !== 'DELAYED_END', 
                        'error-icon': task.delayedEnd && getTrackingEvent(task) === 'DELAYED_END'}"
                                class="flex flex-col w-1/2">
                                {{ getEndTimeDiference(task) }}
                              </div>
                            }
                          </div>
                          <div class="flex flex-row justify-center bg-slate-100 border dark:bg-slate-900">
                            {{ timeRemainingToStart2(task) }}
                            @if (task?.timeRemainingToStart2 < 0 && task.endTaskDate && !task.startTaskDate2) {
                              <div class="flex flex-row text-green-500"
                                >
                                {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToStart2)) }}
                              </div>
                            }
                            @if (!task.endTaskDate && !task.startTaskDate2) {
                              <div>
                                <br>
                                </div>
                              }
                              @if ((task.endTaskDate || task.startTaskDate2) && getTrackingEvent(task) !=='PAUSED') {
                                <div class="flex flex-col w-1/2"
                                  >
                                  @if (task?.startTaskDate2) {
                                    <div>
                                      {{ task.startTaskDate2 | localizeDate: 'H:mm' }}
                                    </div>
                                  }
                                </div>
                              }
                              @if (task.startTaskDate2) {
<div [ngClass]="{'warning-icon': task.delayedStart2 && getTrackingEvent(task) !== 'DELAYED_START2', 
                        'error-icon': task.delayedStart2 && getTrackingEvent(task) === 'DELAYED_START2'}"
                                  class="flex flex-col w-1/2">
                                  {{ getStartTimeDiference2(task) }}
                                </div>
                              }
                            </div>
                            <div class="flex flex-row justify-center border">
                              {{ timeRemainingToEnd2(task) }}
                              @if (task?.timeRemainingToStart2 < 0 || getTrackingEvent(task) === 'SENT' || getTrackingEvent(task) === 'PLANNED' || getTrackingEvent(task) === 'DELAYED_START2') {
                                <div
                                  >
                                  <br>
                                  </div>
                                }
                                @if (task?.timeRemainingToEnd2 > 0 && getTrackingEvent(task) === 'WORKING' && task.startTaskDate2) {
                                  <div class="flex flex-row text-green-500 text-center"
                                    >
                                    {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToEnd2)) }}
                                  </div>
                                }
                                @if (!task.startTaskDate2) {
                                  <div>
                                    <br>
                                    </div>
                                  }
                                  @if (task?.timeRemainingToEnd2 < 0 || getTrackingEvent(task) === 'DONE' || getTrackingEvent(task) === 'DONE_WITH_ERROR') {
                                    <div class="flex flex-col w-1/2">
                                      @if (task?.endTaskDate2) {
                                        <div>
                                          {{ task.endTaskDate2 | localizeDate: 'H:mm' }}
                                        </div>
                                      }
                                    </div>
                                  }
                                  @if ((getTrackingEvent(task) !== 'WORKING') || getTrackingEvent(task) === 'DONE' || getTrackingEvent(task) === 'DONE_WITH_ERROR') {
<div [ngClass]="{'warning-icon': task.delayedEnd2 && getTrackingEvent(task) !== 'DELAYED_END2', 
                        'error-icon': task.delayedEnd2 && getTrackingEvent(task) === 'DELAYED_END2'}"
                                      class="flex flex-col w-1/2">
                                      {{ getEndTimeDiference2(task) }}
                                    </div>
                                  }
                                </div>
                              </ng-template>

                              <!-- COLUMNA REALIZADO TAREAS QUE CONSUMEN TIEMPO CREADAS DESDE EL MÓVIL -->
                              <ng-template #doneTimeConsumingMobile let-task>
                                @if (!task.endTaskDate) {
                                  <div class="flex flex-row justify-center border">
                                    <br>
                                    </div>
                                  }
                                  @if (task.endTaskDate) {
                                    <div class="flex flex-row justify-center border">
                                      <div class="flex flex-col w-1/2">
                                        <br>
                                        </div>
                                        <div matTooltip="{{ 'services.taskPlanning.workingTime' | transloco }}" class="flex flex-col w-1/2">
                                          {{ workingTime(task) }}
                                        </div>
                                      </div>
                                    }
                                    <div class="flex flex-row justify-center border bg-slate-100 dark:bg-slate-900">
                                      <div class="flex flex-col w-1/2">
                                        {{ 'services.taskPlanning.started' | transloco }}
                                      </div>
                                      <div class="flex flex-col w-1/2">
                                        {{ task.startTaskDate | localizeDate: 'H:mm' }}
                                      </div>
                                    </div>
                                    @if (getTimeFromStartMobile(task) > 10 && task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
<div [ngClass]="{'warning-icon': task.timeFromStart > 480, 
        'text-green-500': task.timeFromStart < 480}" class="flex flex-row justify-center border">
        <div class="flex flex-col w-1/2">
            <div></div>
        </div>
        <div class="flex flex-col w-1/2">
            {{ printTimeFromMinutes(task.timeFromStart) }}
        </div>
    </div>
}
    @if (getTimeFromStartMobile(task) < 10 && task.status !== 'DONE'  && task.status !== 'DONE_WITH_ERROR') {
<div
        class="flex flex-row justify-center border">
                                        <br>
                                        </div>
                                      }
                                      @if (task.status === 'DONE' || task.status === 'DONE_WITH_ERROR') {
                                        <div class="flex flex-row justify-center border">
                                          <div class="flex flex-col w-1/2">
                                            {{ 'services.taskPlanning.ended' | transloco }}
                                          </div>
                                          <div class="flex flex-col w-1/2">
                                            {{ task.endTaskDate | localizeDate: 'H:mm' }}
                                          </div>
                                        </div>
                                      }
                                    </ng-template>

                                    <!-- COLUMNA REALIZADO TAREAS QUE NO CONSUMEN TIEMPO CREADAS DESDE EL BACKOFFICE -->
                                    <ng-template #doneNoTimeConsumingBO let-task>
                                      <div class="flex flex-row justify-center border">
                                        <br>
                                        </div>
                                        {{ timeRemainingToStart(task) }}
                                        <div class="flex flex-row justify-center text-green-500 border bg-slate-100 dark:bg-slate-900">
                                          @if (task?.timeRemainingToStart < 0 && task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
                                            <div class="flex flex-row justify-center">
                                              {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToStart)) }}
                                            </div>
                                          }
                                          @if (task?.timeRemainingToStart > 0 || task.status === 'DONE' || task.status === 'DONE_WITH_ERROR') {
                                            <br>
                                            }
                                          </div>
                                          <div class="flex flex-row justify-center border">
                                            <br>
                                            </div>
                                            <div class="flex flex-row justify-center border bg-slate-100 dark:bg-slate-900">
                                              @if (task?.timeRemainingToStart < 0) {
                                                <br>
                                                }
                                                {{ timeRemainingToEnd(task) }}
                                                @if (task?.timeRemainingToEnd > 0 && task?.timeRemainingToStart > 0 && task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
                                                  <div
                                                    class="flex flex-row justify-center text-green-500">
                                                    {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToEnd)) }}
                                                  </div>
                                                }
                                                @if (task?.timeRemainingToEnd < 0 && task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
                                                  <div class="flex flex-row justify-center w-full">
                                                    @if (getTrackingEvent(task) === 'DELAYED_END' || task?.timeRemainingToEnd < 0) {
                                                      <div
                                                        [ngClass]="{'warning-icon': endedDelayed(task)}" class="flex flex-col w-1/2">
                                                        {{ reverseDate(getDate()) }}
                                                      </div>
                                                    }
                                                    @if (getTrackingEvent(task) === 'DELAYED_END' || task?.timeRemainingToEnd < 0) {
                                                      <div
                                                        class="flex flex-col w-1/2 warning-icon">
                                                        {{ getEndTimeDiference(task) }}
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                                @if (task.status === 'DONE' || task.status === 'DONE_WITH_ERROR') {
                                                  <div class="flex flex-row justify-center w-full">
                                                    @if (getTrackingEvent(task) === 'DONE' || getTrackingEvent(task) === 'DONE_WITH_ERROR') {
                                                      <div [ngClass]="{'warning-icon': endedDelayed(task)}"
                                                        class="flex flex-col w-1/2">
                                                        {{ reverseDate(getDate('end', task)) }}
                                                      </div>
                                                    }
                                                    @if ((getTrackingEvent(task) === 'DONE' || getTrackingEvent(task) === 'DONE_WITH_ERROR') && !endedDelayed(task)) {
                                                      <div class="flex flex-col w-1/2">
                                                        {{ task.endTaskDate | localizeDate: 'H:mm' }}
                                                      </div>
                                                    }
                                                    @if ((getTrackingEvent(task) === 'DONE' || getTrackingEvent(task) === 'DONE_WITH_ERROR') && endedDelayed(task)) {
                                                      <div
                                                        class="flex flex-col w-1/2 warning-icon">
                                                        {{ getEndTimeDiference(task) }}
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            </ng-template>

                                            <!-- COLUMNA REALIZADO TAREAS QUE NO CONSUMEN TIEMPO CREADAS DESDE EL MÓVIL -->
                                            <ng-template #doneNoTimeConsumingMobile let-task>
                                              @if (task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
                                                <div class="flex flex-row justify-center border">
                                                  <br>
                                                  </div>
                                                }
                                                @if (task.status === 'DONE' || task.status === 'DONE_WITH_ERROR') {
                                                  <div class="flex flex-row justify-center border">
                                                    <div class="flex flex-col w-1/2">
                                                      <br>
                                                      </div>
                                                      <div matTooltip="{{ 'services.taskPlanning.workingTime' | transloco }}" class="flex flex-col w-1/2">
                                                        {{ workingTime(task) }}
                                                      </div>
                                                    </div>
                                                  }
                                                  {{ timeRemainingToStart(task) }}
                                                  <div class="flex flex-row justify-center border bg-slate-100 dark:bg-slate-900">
                                                    <div class="flex flex-col w-1/2">
                                                      {{ reverseDate(getDate('start', task)) }}
                                                    </div>
                                                    <div class="flex flex-col w-1/2">
                                                      {{ task.startTaskDate | localizeDate: 'H:mm' }}
                                                    </div>
                                                  </div>
                                                  @if (task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
                                                    <div class="flex flex-row justify-center border">
                                                      <div class="flex flex-col w-1/2">
                                                        <br>
                                                        </div>
                                                        <div [ngClass]="{'error-icon': task.workingTime > 10080,  'text-green-500': task.workingTime < 10080}"
                                                          class="flex flex-col w-1/2">
                                                          {{ workingTime(task) }}
                                                        </div>
                                                      </div>
                                                    }
                                                    @if (task.status === 'DONE' || task.status === 'DONE_WITH_ERROR') {
                                                      <div class="flex flex-row justify-center border">
                                                        <div class="flex flex-col w-1/2">
                                                          {{ reverseDate(getDate('end', task)) }}
                                                        </div>
                                                        <div class="flex flex-col w-1/2">
                                                          {{ task.endTaskDate | localizeDate: 'H:mm' }}
                                                        </div>
                                                      </div>
                                                    }
                                                  </ng-template>

                                                  <!-- COLUMNA REALIZADO ASIGNACIÓN DE TAREAS -->
                                                  <ng-template #doneTaskAssignment let-task>
                                                    <div class="flex flex-row justify-center border">
                                                      <br>
                                                      </div>
                                                      <div class="flex flex-row justify-center border bg-slate-100 dark:bg-slate-900">
                                                        <div class="flex flex-col w-1/2">
                                                          {{ task.scheduled_from_time | localizeDate: 'dd/MM/yyyy' }}
                                                        </div>
                                                        <div class="flex flex-col w-1/2">
                                                          {{ task.scheduled_from_time | localizeDate: 'H:mm' }}
                                                        </div>
                                                      </div>
                                                      <div class="flex flex-row justify-center border">
                                                        <div class="flex flex-col w-1/2">
                                                          {{ task.scheduled_to_time | localizeDate: 'dd/MM/yyyy' }}
                                                        </div>
                                                        <div class="flex flex-col w-1/2">
                                                          {{ task.scheduled_to_time | localizeDate: 'H:mm' }}
                                                        </div>
                                                      </div>
                                                      {{ timeRemainingToEnd(task) }}
                                                      @if (task.status !== 'WORKING' && task.status !== 'DONE' && task.status !== 'DONE_WITH_ERROR') {
                                                        <div
                                                          class="flex flex-row justify-center text-green-500 border bg-slate-100 dark:bg-slate-900">
                                                          {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToEnd)) }}
                                                        </div>
                                                      }
                                                      @if (task.status === 'WORKING' && task?.timeRemainingToEnd > 0) {
                                                        <div
                                                          class="flex flex-row justify-center text-green-500 border bg-slate-100 dark:bg-slate-900">
                                                          {{ printTimeRemaining($safeNavigationMigration(task?.timeRemainingToEnd)) }}
                                                        </div>
                                                      }
                                                      @if (task.status === 'WORKING' && task?.timeRemainingToEnd < 0) {
                                                        <div
                                                          class="flex flex-row justify-center text-green-500 border bg-slate-100 dark:bg-slate-900">
                                                          <br>
                                                          </div>
                                                        }
                                                        @for (taskType of task.taskAssignmentSummary; track taskType; let i = $index) {
                                                          <div
                                                            [ngClass]="{'bg-slate-100 dark:bg-slate-900': indexImpar(i, task)}" class="flex flex-row justify-center border">
                                                            <div class="flex flex-col w-1/2">
                                                              {{ taskType?.count }}
                                                            </div>
                                                            @if (taskType.minutes > 0) {
                                                              <div class="flex flex-col w-1/2">
                                                                {{ minutesToString($safeNavigationMigration(taskType?.minutes)) }}
                                                              </div>
                                                            }
                                                            @if (taskType.minutes <= 0) {
                                                              <div class="flex flex-col w-1/2">
                                                                -
                                                              </div>
                                                            }
                                                          </div>
                                                        }
                                                      </ng-template>